import { render, staticRenderFns } from "./SectionWarehouseSelect.vue?vue&type=template&id=c8351d2e&scoped=true&"
import script from "./SectionWarehouseSelect.vue?vue&type=script&lang=js&"
export * from "./SectionWarehouseSelect.vue?vue&type=script&lang=js&"
import style0 from "./SectionWarehouseSelect.vue?vue&type=style&index=0&id=c8351d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8351d2e",
  null
  
)

export default component.exports